<template>
    <div :class="theme.card">
        <slot></slot>
    </div>
</template>
<script>
import theme from './theme.scss';

export default {
    name: 'card',
    data() {
        return {
            theme,
        }
    }
}
</script>



// WEBPACK FOOTER //
// Card.vue?06d7a991